import useSWR from 'swr'

import { FetchError } from '../fetchError'
import { FetchResponse } from '../fetchResponse'
import { FetchResult } from '../fetchResult'
import { fetchJson, fetchWithoutAuth } from '../fetchers'
import { Project, Tenant } from '../models'

export function useAllTenants(): FetchResult<Tenant[]> {
  const { data, error, mutate } = useSWR<FetchResponse<Tenant[]>, FetchError>(
    `/tenants`,
    fetchJson<Tenant[]>,
    {
      errorRetryCount: 0,
    },
  )

  return {
    data: data?.body,
    isLoading: !data && !error,
    error: error,
    mutate: mutate,
    etag: data?.etag,
  }
}

export function useIsMaintenanceModeEnabled(): FetchResult<boolean> {
  const { data, error, mutate } = useSWR<FetchResponse<boolean>, FetchError>(
    `tenants/ismaintenanceactive`,
    fetchWithoutAuth<boolean>,
    {
      errorRetryCount: 0,
    },
  )
  return {
    data: data?.body,
    isLoading: !data && !error,
    error: error,
    mutate: mutate,
    etag: data?.etag,
  }
}

export function useTenantById(tenantId: string): FetchResult<Tenant> {
  const { data, error, mutate } = useSWR<FetchResponse<Tenant>, FetchError>(
    tenantId ? `/tenants/${tenantId}` : null,
    fetchJson<Tenant>,
    {
      errorRetryCount: 0,
    },
  )

  return {
    data: data?.body,
    isLoading: !data && !error,
    error: error,
    mutate: mutate,
    etag: data?.etag,
  }
}

export function useAllProjectsByTenantId(
  tenantId: string,
): FetchResult<Project[]> {
  const { data, error, mutate } = useSWR<FetchResponse<Project[]>, FetchError>(
    tenantId ? `/tenants/${tenantId}/projects` : null,
    fetchJson<Project[]>,
    {
      errorRetryCount: 0,
    },
  )

  return {
    data: data?.body,
    isLoading: !data && !error,
    error: error,
    mutate: mutate,
    etag: data?.etag,
  }
}

export function useProjectByTenantIdAndProjectId(
  tenantId: string,
  projectId: string | null | undefined,
): FetchResult<Project> {
  const { data, error, mutate } = useSWR<FetchResponse<Project>, FetchError>(
    tenantId && projectId ? `/tenants/${tenantId}/projects/${projectId}` : null,
    fetchJson<Project>,
    {
      errorRetryCount: 0,
    },
  )

  return {
    data: data?.body,
    isLoading: !data && !error,
    error: error,
    mutate: mutate,
    etag: data?.etag,
  }
}
